import { render, staticRenderFns } from "./ActaReunionPqr.vue?vue&type=template&id=db69f7d2&scoped=true"
import script from "./ActaReunionPqr.vue?vue&type=script&lang=js"
export * from "./ActaReunionPqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db69f7d2",
  null
  
)

export default component.exports